import * as C from '../constants';
import * as React from 'react';
import { Store } from 'redux';
import { IndexRedirect, Route, Redirect } from 'react-router';
import {
  requireAuthOnEnter,
  requireAuthOnChange,
  makeGetComponent,
} from './utils';
import { getEnterpriseRoute } from './EnterpriseRoute';
import { getNonAuthenticationRoute } from './NonAuthenticationRoute';

export const getLegacyRoute = (store: Store<RootState>, homeRoot: string) => (
  <Route getComponent={makeGetComponent('LegacyStylesWrapper')}>
    <Route
      path="/"
      onEnter={requireAuthOnEnter(store)}
      onChange={requireAuthOnChange(store)}
      getComponent={makeGetComponent('App')}
    >
      <IndexRedirect to={homeRoot} />
      <Route path="folder" getComponent={makeGetComponent('FolderPage')} />
      {getEnterpriseRoute(store)}
      <Route
        path="my-data-page/search"
        getComponent={makeGetComponent(
          'SearchProductsUserPage/SearchProductsUserPageContainer'
        )}
      />
      <Redirect from="/my-data-page*" to="/dashboard/benchmark" />
      <Route
        path="company/new"
        getComponent={makeGetComponent('CreateCompanyPage')}
      />

      <Route
        path="data"
        getComponent={makeGetComponent('DataGatePage/index')}
      />
      {/* START DEPRECATE SOON: this is the old data page. We expect to deprecate this. */}
      <Route
        path={`data/channel/${
          C.LEGACY_DATA_PAGE.DUMMY_SS_DEFAULT_CHANNEL_ID
        }/view`}
        getComponent={makeGetComponent('DataPage')}
      />
      {/* END DEPRECATE SOON */}
      <Route
        path="data/channel/:channelId/view"
        getComponent={makeGetComponent('ChannelDataView')}
      />
      <Route
        path="data/channel/:channelId/manage"
        getComponent={makeGetComponent('ChannelDataPrice')}
      />
      <Route
        path="credit"
        getComponent={makeGetComponent('CreditPageIFrame')}
      />
      <Route path="refer" getComponent={makeGetComponent('SendReferralPage')} />
      <Route
        path="profile/:companyId/channel/:channelId"
        getComponent={makeGetComponent('ChannelProfile')}
      />
    </Route>
    {getNonAuthenticationRoute(store)}
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/LegacyRoute.tsx